import { render, staticRenderFns } from "./ordertrains.vue?vue&type=template&id=193f5ba3&scoped=true"
import script from "./ordertrains.vue?vue&type=script&lang=js"
export * from "./ordertrains.vue?vue&type=script&lang=js"
import style0 from "./ordertrains.vue?vue&type=style&index=0&id=193f5ba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f5ba3",
  null
  
)

export default component.exports